import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import { hotelData } from "../../config/getHotel";

export default function RouteSEO() {
  const location = useLocation();

  const path = location.pathname.toLowerCase();

  const routeMap = {
    "/": "home",
    "/amenities": "amenities",
    "/about": "about", 
    "/contact": "contact",
    "/gallery": "gallery",
    "/menu": "menu",
    "/wedding-packages": "wedding",
    "/privacy-policy": "privacy",
    "/legal": "legal",
    "/terms-and-conditions": "terms",
     "/offers": "offers",
  };

  const seoKey = routeMap[path] || "home";
  const seoData = hotelData.seo?.[seoKey] || {};

  return (
    <SEO
      title={seoData.title}
      description={seoData.description}
    />
  );
}